// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router' // api: https://github.com/vuejs/vue-router
import VueCookie from 'vue-cookie'
import httpRequest from '@/utils/httpRequest' // api: https://github.com/axios/axios
import PubSub from 'pubsub-js'
import User from '@/utils/UserUtil'
import { Message, MessageBox } from 'element-ui'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import loading from './assets/loading'
import messageTips from './assets/messageTips'
import store from './store/store'
import nstlCommonFile from 'nstl-common-file-2.1'
import 'nstl-common-file-2.1/lib/nstl.css'

const querystring = require("querystring");

Vue.component(Message.name, MessageBox);
Vue.use(VueCookie)
Vue.use(loading);
Vue.use(messageTips);
Vue.use(ElementUI);


// 挂载全局
Vue.prototype.$http = httpRequest; // ajax请求方法
Vue.prototype.PubSub = PubSub; // 组件发布订阅消息
Vue.prototype.$user = User;
Vue.prototype.$queryString = querystring;
Vue.prototype.$message = MessageBox;
Vue.config.productionTip = false;
Vue.use(nstlCommonFile);


/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    store,
    components: { App },
    template: '<App/>'
})


// WEBPACK FOOTER //
// ./src/main.js